module.exports = __webpack_public_path__ + "media/images/faire_logo@2x-6ff774c3ba9b562b55617866ecbdd562.png";